'use client';

import { c as _c } from "react/compiler-runtime";
import { filterUsageCollection } from '@/comps/FilterPicker/favorites';
import { useLiveQuery } from '@tanstack/react-db';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
const USAGE_WINDOW_LIMIT = 200;
class StorageUsageError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'StorageUsageError';
  }
}
async function getStorageUsage() {
  try {
    const estimate = await navigator.storage.estimate();
    if (!estimate.usage || !estimate.quota) return 0;
    const percentage = Math.round(estimate.usage / estimate.quota * 100);
    return percentage;
  } catch {
    return 0;
  }
}
export function FilterUsageCleanupListener() {
  const $ = _c(8);
  const {
    data: filterUsage
  } = useLiveQuery(_temp2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["storage-usage"],
      queryFn: getStorageUsage
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: storageUsage
  } = useQuery(t0);
  let t1;
  let t2;
  if ($[1] !== filterUsage || $[2] !== queryClient) {
    t1 = () => {
      if (filterUsage.length > 0) {
        filterUsage.forEach(_temp3);
      }
      queryClient.invalidateQueries({
        queryKey: ["storage-usage"]
      });
    };
    t2 = [filterUsage, queryClient];
    $[1] = filterUsage;
    $[2] = queryClient;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== storageUsage) {
    t3 = () => {
      if (storageUsage && storageUsage > 90) {
        throw new StorageUsageError(`Local storage usage is ${storageUsage}%`);
      }
    };
    t4 = [storageUsage];
    $[5] = storageUsage;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  return null;
}
function _temp3(usage) {
  try {
    filterUsageCollection.delete(usage.id, {});
  } catch {}
}
function _temp2(q) {
  return q.from({
    usage: filterUsageCollection
  }).orderBy(_temp, "desc").offset(USAGE_WINDOW_LIMIT);
}
function _temp(t) {
  return t.usage.timestamp;
}